export default "__VITE_ASSET__db270a0f__"